import React from 'react';
import { ExpandedColumnItem } from './styled';
import { SmallText } from 'ds/components/typography';

interface ExpandedInfoItemProps extends React.AllHTMLAttributes<HTMLDivElement> {
  label: string;
  value: string | number;
}

export const ExpandedInfoItem: React.FC<ExpandedInfoItemProps> = ({ label, value, ...props }) => (
  <ExpandedColumnItem {...props}>
    <SmallText>{label}</SmallText>
    <SmallText>{value}</SmallText>
  </ExpandedColumnItem>
);
